export default __webpack_public_path__ + "static/media/icon-empty-search.92ad0e0d.svg";